import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Check, BadgeCheck, ArrowRight } from "lucide-react";import { eur, scrollToId } from "@/lib/format";

export default function QuickView({ product, open, onClose }) {
    const [imgIdx, setImgIdx] = useState(0);
    const tid = product.slug;

    return (
        <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
            <DialogContent
                className="max-w-3xl bg-spidey-card border border-zinc-800 text-zinc-300 p-0 overflow-hidden max-h-[90vh] overflow-y-auto"
                data-testid={`stripe-checkout-dialog-${tid}`}
            >
                <div className="grid md:grid-cols-2">
                    <div className="relative bg-spidey-panel aspect-square">
                        <img src={product.gallery[imgIdx]} alt={product.name} className="w-full h-full object-cover" />
                        <div className="absolute bottom-3 left-3 flex gap-2">
                            {product.gallery.map((g, i) => (
                                <button
                                    key={i}
                                    onClick={() => setImgIdx(i)}
                                    aria-label={`Photo ${i + 1}`}
                                    className={`w-8 h-8 rounded-lg overflow-hidden border transition-all ${i === imgIdx ? "border-spidey-red" : "border-zinc-700 opacity-60 hover:opacity-100"}`}
                                >
                                    <img src={g} alt="" className="w-full h-full object-cover" />
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="p-6 sm:p-8">
                        <DialogHeader>
                            <span className="flex items-center gap-2 text-[11px] font-mono-brand uppercase tracking-[0.2em] text-spidey-neon">
                                <BadgeCheck size={14} />
                                Édition Spider-Web
                            </span>
                            <DialogTitle className="text-left text-2xl font-bold text-white mt-2 leading-snug">
                                {product.name}
                            </DialogTitle>
                        </DialogHeader>

                        <p className="mt-4 text-sm leading-relaxed text-zinc-400">{product.description}</p>

                        <ul className="mt-4 space-y-2">
                            {product.features.map((f) => (
                                <li key={f} className="flex items-start gap-2 text-[13px] text-zinc-300">
                                    <Check size={14} className="text-spidey-red mt-0.5 shrink-0" />
                                    {f}
                                </li>
                            ))}
                        </ul>

                        <div className="mt-6 flex items-center justify-between">
                            <span className="font-display text-3xl text-white">{eur(product.price)}</span>
                            {product.original_price > product.price && (
                                <span className="text-xs text-zinc-500 line-through">{eur(product.original_price)}</span>
                            )}
                        </div>

                        <button
                            onClick={() => {
                                onClose();
                                scrollToId("products");
                            }}
                            className="mt-5 w-full flex items-center justify-center gap-2 bg-spidey-red hover:bg-spidey-neon text-white font-bold uppercase tracking-wider text-sm py-3.5 rounded-full transition-all hover:shadow-[0_0_30px_rgba(230,0,38,0.5)]"
                        >
                            Choisir ma taille
                            <ArrowRight size={16} />
                        </button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
